import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    assessmentsControlId: String,
    userId: String
  }

  declare readonly assessmentsControlIdValue: string
  declare readonly userIdValue: string

  submit (event: Event): void {
    const linkedEvidenceIdsField = document.getElementById('linked-evidence-ids')
    if (linkedEvidenceIdsField === null) {
      return
    }

    const evidenceIds = (linkedEvidenceIdsField as HTMLInputElement).value ?? ''
    if (evidenceIds === '') {
      return
    }

    const formData = new FormData()
    formData.append('evidence_ids', evidenceIds)

    const url = `/genius/evidences/insights?assessments_control_id=${this.assessmentsControlIdValue}`

    void this.submitRequest(url, formData)
  }

  private async submitRequest (url: string, formData: FormData): Promise<void> {
    try {
      const response = await fetch(url, {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'text/vnd.turbo-stream.html',
          'X-CSRF-Token': this.getCSRFToken()
        },
        credentials: 'same-origin'
      })

      if (response.ok) {
        const html = await response.text()
        const Turbo = (window as any).Turbo
        Turbo.renderStreamMessage(html)
      } else {
        throw new Error('Network response was not ok')
      }
    } catch (error) {
      console.error('Error submitting genius insights:', error)
    }
  }

  private getCSRFToken (): string {
    const token = document.querySelector('meta[name="csrf-token"]')
    return token?.getAttribute('content') ?? ''
  }
}
